<template>
  <div>
    <card-panel-list>
      <applications-card-list-item
        v-for="item in items"
        :key="item.id"
        :title="item.job_title"
        :description="item.company_title"
        :location="item.job_location"
        :status="item.status"
        :date="item.modified"
        :clickable="clickable"
        @click="$emit('click', item)">
      </applications-card-list-item>
    </card-panel-list>
  </div>
</template>


<script>

import CardPanelList from 'top20common/components/card-panel/CardPanelList';

import ApplicationsCardListItem from './ApplicationsCardListItem';

export default {
  props: {
    items: Array,
    clickable: Boolean
  },
  components: {
    CardPanelList,
    ApplicationsCardListItem
  }
};
</script>
